import { useQuery } from 'react-query';
import { fetchDesktopAppDownloadUrls } from '@services/appDownloadUrls';
import { queryKeys } from '@config/queryKeys';

const FIVE_MINUTES_MS = 5 * 60 * 1000;

const EMPTY_PLATFORM_CONFIG = { downloadUrl: null, currentVersion: null };
const EMPTY_DOWNLOAD_URLS = {
  windows: EMPTY_PLATFORM_CONFIG,
  macos: EMPTY_PLATFORM_CONFIG,
  linux: EMPTY_PLATFORM_CONFIG,
};

/**
 * Desktop app installer download URL + version for windows/macos/linux, read
 * directly from Firestore (`appVersionConfig`) — the single source of truth
 * also used by the "App Versions" admin page and (server-side) partner
 * provisioning.
 *
 * staleTime matches the backend's in-memory cache TTL (app-download-config.js)
 * so a staff publish is reflected within roughly the same window everywhere,
 * without refetching on every render.
 */
export function useDesktopAppDownloadUrls() {
  const { data, isLoading, isError } = useQuery({
    queryKey: queryKeys.appDownloadUrls.mapping,
    queryFn: fetchDesktopAppDownloadUrls,
    staleTime: FIVE_MINUTES_MS,
  });

  return {
    downloadUrls: data || EMPTY_DOWNLOAD_URLS,
    isLoading,
    isError,
  };
}
